import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function ThorntonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Thornton"
        state="Colorado"
        stateAbbr="CO"
        route="/thornton"
        title="Emergency Passport Thornton, CO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Thornton, CO — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north Denver metro families, business travelers, and students near DIA."
        geoPlacename="Thornton, Colorado"
        geoPosition="39.8680;-104.9719"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Colorado"
        statePageRoute="/states/colorado"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <ServicesSection />
      <LocalAreaSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <HowItWorksSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/thornton" state="CO" />
      <FinalCTA />
    </div>
  );
}